<template>
    <div class="inline-flex" :class="{
        'relative overflow-hidden': onlyBg
    }">
        <v-skeleton
            v-if="!isLoaded && loading"
            class="h-full select-none"
            :class="{
                [loading]: true,
                [imgClass]: true,
                'absolute left-0 right-0 w-full object-cover object-center [&~*]:z-[1]': onlyBg,
            }"
        />
        <img
            class="h-full select-none"
            :class="{
                '!w-0 !h-0': !isLoaded,
                [imgClass]: true,
                'absolute left-0 right-0 w-full object-cover object-center [&~*]:z-[1]': onlyBg,
            }"
            :style="{
                'object-fit': cover ? 'cover' : objectFit,
            }"
            :src="path ?? require(`@/shared/assets/${name ? `img/${name}` : 'svg/no-image.svg'}`)"
            :alt="alternate"
            @error="() => {
                if (path == src && src != undefined) path = require(`@/shared/assets/svg/no-image.svg`);
            }"
            loading="lazy"
            @load="isLoaded = true"
        />
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'v-img',
    data () {
        const src = this.src
        return {
            path: src,
            isLoaded: false,
        }
    },
    watch: {
        src(val) {
            this.isLoaded = false;
            this.path = val;
        },
    },
    props: {
        src: {
            type: String,
            default: undefined
        },
        name: {
            type: String,
            default: undefined
        },
        alternate: {
            type: String,
            default: 'Картинка не найден!'
        },
        objectFit: {
            type: String,
            default: 'cover'
        },
        cover: {
            type: Boolean,
            default: false
        },
        imgClass: {
            type: String,
            default: ''
        },
        onlyBg: {
            type: Boolean,
            default: false
        },
        loading: {
            type: String,
            default: ''
        },
    },
}
</script>